function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { ToolbarButton, ToolbarListbox } from "@graphiql/react";
import GraphiQL from "graphiql";
import { graphQLFetcher } from "/services/graphiql-helper-service";
import { useCallback, useEffect, useState } from "react";
import Versioning from "monday-ui-react-core/dist/icons/Versioning";
import Locked from "monday-ui-react-core/dist/icons/Locked";
import { StylesGraphiqlComponent } from "./graphiql-component.scss";
import { defaultQuery } from "./graphiql-default-query";
import "graphiql/graphiql.css";
const VERSIONS_QUERY = "query { versions { kind value } }";
const GraphiqlComponent = ({ changeToken, onAuthorized, token })=>{
    const [apiVersions, setApiVersions] = useState();
    const [version, setVersion] = useState();
    const fetcher = useCallback((params, opts)=>Promise.resolve(token ? graphQLFetcher(params, _object_spread_props(_object_spread({}, opts), {
            onAuthorized,
            tokenString: token,
            version
        })) : undefined), [
        onAuthorized,
        version,
        token
    ]);
    useEffect(()=>{
        fetcher({
            query: VERSIONS_QUERY
        }).then((result)=>{
            var _result_data;
            const newApiVersions = result === null || result === void 0 ? void 0 : (_result_data = result.data) === null || _result_data === void 0 ? void 0 : _result_data.versions;
            setApiVersions(newApiVersions);
            setVersion((ver)=>{
                const newVersion = ver && (newApiVersions === null || newApiVersions === void 0 ? void 0 : newApiVersions.find((v)=>v.value === ver)) || (newApiVersions === null || newApiVersions === void 0 ? void 0 : newApiVersions.find((v)=>v.kind === "stable"));
                return newVersion === null || newVersion === void 0 ? void 0 : newVersion.value;
            });
        });
    }, [
        fetcher
    ]);
    return /*#__PURE__*/ _jsx(StylesGraphiqlComponent, {
        className: "graphiql-component-container",
        children: /*#__PURE__*/ _jsxs(GraphiQL, {
            defaultQuery: defaultQuery,
            fetcher: fetcher,
            toolbar: {
                additionalContent: /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx(ToolbarButton, {
                            label: "Change token",
                            onClick: changeToken,
                            children: /*#__PURE__*/ _jsx(Locked, {
                                className: "graphiql-toolbar-icon",
                                "aria-hidden": "true"
                            })
                        }),
                        (apiVersions === null || apiVersions === void 0 ? void 0 : apiVersions.length) && version && /*#__PURE__*/ _jsx(ToolbarListbox, {
                            button: /*#__PURE__*/ _jsx(ToolbarButton, {
                                children: /*#__PURE__*/ _jsx(Versioning, {
                                    className: "graphiql-toolbar-icon",
                                    "aria-hidden": "true"
                                })
                            }),
                            label: "Selected version",
                            value: version,
                            onChange: setVersion,
                            children: apiVersions.map((ver)=>/*#__PURE__*/ _jsxs(ToolbarListbox.Option, {
                                    value: ver.value,
                                    children: [
                                        ver.value,
                                        ver.kind !== ver.value ? ` (${ver.kind})` : null
                                    ]
                                }, ver.value))
                        })
                    ]
                })
            },
            children: [
                /*#__PURE__*/ _jsx(GraphiQL.Logo, {
                    children: "API Playground"
                }),
                /*#__PURE__*/ _jsx(GraphiQL.Footer, {
                    children: /*#__PURE__*/ _jsx("div", {
                        className: "disclaimer-text",
                        children: "This explorer uses your real monday.com data"
                    })
                })
            ]
        })
    });
};
export default GraphiqlComponent;
